import React from 'react'
import { t } from '../../../config/i18n'
import styles from './AppointmentStatus.module.scss'
import cn from 'classnames'

export const AppointmentCancelled = () => <div className={cn(styles.root, styles.cancelled)}>
  {t.appointment.cancelled}
</div>;
